

<div class="row">
	<button style="padding: 0px 10px 0px 10px; margin-left:15px;" class="btn btn-success btn-purchasenewpack" (click)="generatePurchaseReport()">Generate Expense Report</button>
	<input type='text'
           style='color:black;padding: 0px 0px 0px 10px; margin:0px 0px 0px 10px;'
		   placeholder='Search..'
		   (keyup)='filterPurchases()' [(ngModel)]="searchText"/>
	<form style="padding-left: 50px;" [formGroup]="form">
		<div class="col-lg-8" style="max-width: 100%;">
			<app-service-period formControlName="period" [minDays]="0" [showToolTip]="false"></app-service-period>
			<app-validation-display
				[control]="form.controls.period"
				errorMessage="Start date cannot come after end date.">
			</app-validation-display>
		</div>
	</form>
	<span style="padding-left: 50px; padding-top: 10px; margin-left:15px; vertical-align: middle; text-align: center;">Show Incomplete Purchases</span>
	<label class="switch" style="padding-left: 10px; top: 5px; margin-left:15px; vertical-align: middle; text-align: center;">	
	<input		
		id="shouldNotifyUserCreated" 
		[(ngModel)]="displayIncomplete"
		type="checkbox" class="form-control" 
		(change)="filterPurchases();" 
		style="padding-left: 10px; margin-left:15px; vertical-align: middle; text-align: center;">
	<span class="slider round"></span>
	</label>
</div>
<br>

<ngx-loading [show]="loading"></ngx-loading>

<ngx-datatable
			   class='material striped datatable datatable-safari-fix'
			   [rows]='display'
			   [columnMode]='"force"'
			   [headerHeight]='40'
			   [footerHeight]='20'
			   [scrollbarV]="true"
			   [rowHeight]="40"
			   [reorderable]="true"
			   [sorts]="[{prop: 'datePurchased', dir: 'desc'}]"
			   [messages]="{emptyMessage:'Nothing to see here'}">						

	<ngx-datatable-column prop="description" [sortable]="true">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Purchase Name
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.description}}
		</ng-template>
	</ngx-datatable-column>  		   
		
	<ngx-datatable-column prop="datePurchased" [sortable]="true" >
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Date Purchased
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.datePurchased | date:'MM-dd-yyyy hh:mm a z'}}
		</ng-template>
	</ngx-datatable-column>

	  <ngx-datatable-column prop="userEmail" [sortable]="true" >
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
				<span (click)="sort()" >
					Purchased By
				</span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template >
				{{row.userEmail}}
			</ng-template>
		</ngx-datatable-column>

	  <ngx-datatable-column name="totalAmount">
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
				<span (click)="sort()" >
					Total Amount / Total Tax
				</span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template >
				${{((row.totalAmount - row.amountOff > 1 || row.totalAmount - row.amountOff <= 0) ? (row.totalAmount - row.amountOff) : 1.00) | number : '1.2-2'}} / ${{row.totalTax | number : '1.2-2'}}
			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column name="purchaseComplete" [sortable]="true">
				<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
					<span (click)="sort()" >
						Status
					</span>
				</ng-template>
				<ng-template let-row="row" ngx-datatable-cell-template >
					{{ row.refundId ? "Refunded" : (row.purchaseComplete ? "Complete" : "Incomplete")}} 
				</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column name="details" [width]='50' >
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
				<span (click)="sort()" >
					Actions
				</span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template >
			  <button (click)="openPurchaseDetails(row);">Details</button>
			  <button (click)="refundPurchase(row.purchaseId)">Refund</button>
			</ng-template>
		  </ngx-datatable-column>

</ngx-datatable>


				

							
				 
